import { render, staticRenderFns } from "./hostRegister.vue?vue&type=template&id=7ffa9574&scoped=true&"
import script from "./hostRegister.vue?vue&type=script&lang=js&"
export * from "./hostRegister.vue?vue&type=script&lang=js&"
import style0 from "./hostRegister.vue?vue&type=style&index=0&id=7ffa9574&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffa9574",
  null
  
)

export default component.exports